import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rank',
})
export class RankPipe implements PipeTransform {
  transform(value: number): string {
    if (value === 1) {
      return `${value}<sup>` + $localize`er` + `</sup>`;
    } else {
      return `${value}<sup>` + $localize`e` + `</sup>`;
    }
  }
}
